import { useState } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import Swal from "sweetalert2";
import { createClaimAndLegalCostService } from "../services/createClaimAndLegalCost.service";

const initialState = {
  accident: "",
  identification: "",
  accountingDate: "",
  accountCode1: "",
  accountCode2: "",
  voucherNumber: "",
  thirdPartyIdentificationName: "",
  detailConcept: "",
  initialBalance: "",
  creditMovement: "",
  finalBalance: "",
  legalReport: null,
  internalCode: "",
  claimDate: "",
  claimDescription: "",
  lossProbability: "",
};

export const useClaimsAndLegalCostsCommand = (refresh) => {
  const fetchData = useFetch();
  const [errors, setErrors] = useState({ hasErrors: false, errors: {} });
  const [claimsAndLegalCosts, setClaimsAndLegalCosts] = useState(initialState);

  const handleChangeClaimsAndLegalCosts = ({ name, value }) => {
    setClaimsAndLegalCosts((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const createClaimsAndLegalCosts = async (claimsAndLegalCosts) => {
    try {
      const isValid = validations(claimsAndLegalCosts);
      if (!isValid) return;
      const response = await createClaimAndLegalCostService(fetchData)(
        claimsAndLegalCosts
      );

      refresh?.();
      Swal.fire({
        icon: "success",
        title: "Costos de siniestros registrados",
        text: response.message,
      });
      setClaimsAndLegalCosts(initialState);
      setErrors({ hasErrors: false, errors: {} });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al registrar los costos de siniestros",
      });

      throw error;
    }
  };

  const validations = (claimsAndLegalCosts) => {
    const newErrors = {};

    if (!claimsAndLegalCosts.accident) {
      newErrors.accident = "El siniestro es requerido";
    }
    if (!claimsAndLegalCosts.identification) {
      newErrors.identification = "La identificación es requerida";
    }
    if (!claimsAndLegalCosts.accountingDate) {
      newErrors.accountingDate =
        "La fecha del movimiento contable es requerida";
    }
    if (!claimsAndLegalCosts.accountCode1) {
      newErrors.accountCode1 = "El código de la cuenta es requerido";
    }
    if (!claimsAndLegalCosts.voucherNumber) {
      newErrors.voucherNumber = "El número del comprobante es requerido";
    }
    if (!claimsAndLegalCosts.thirdPartyIdentificationName) {
      newErrors.thirdPartyIdentificationName =
        "El nombre de identificación del tercero es requerido";
    }
    if (!claimsAndLegalCosts.detailConcept) {
      newErrors.detailConcept = "El detalle o concepto es requerido";
    }
    if (!claimsAndLegalCosts.initialBalance) {
      newErrors.initialBalance = "El saldo inicial es requerido";
    }
    if (!claimsAndLegalCosts.creditMovement) {
      newErrors.creditMovement = "El movimiento crédito es requerido";
    }
    if (!claimsAndLegalCosts.finalBalance) {
      newErrors.finalBalance = "El saldo final es requerido";
    }
    if (!claimsAndLegalCosts.legalReport) {
      newErrors.legalReport = "El reporte legal es requerido";
    }
    if (!claimsAndLegalCosts.accountCode2) {
      newErrors.accountCode2 = "El código de la cuenta es requerido";
    }
    if (!claimsAndLegalCosts.internalCode) {
      newErrors.internalCode = "El código interno es requerido";
    }
    if (!claimsAndLegalCosts.claimDate) {
      newErrors.claimDate = "La fecha de reclamo es requerida";
    }
    if (!claimsAndLegalCosts.claimDescription) {
      newErrors.claimDescription = "La descripción del reclamo es requerida";
    }
    if (!claimsAndLegalCosts.lossProbability) {
      newErrors.lossProbability = "La probabilidad de pérdida es requerida";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors({ hasErrors: true, errors: newErrors });
      return false;
    }

    setErrors({ hasErrors: false, errors: {} });
    return true;
  };

  return {
    claimsAndLegalCosts,
    errors,
    handleChangeClaimsAndLegalCosts,
    createClaimsAndLegalCosts,
  };
};
